import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import Swal from 'sweetalert2';
import SpinnerComponent from '../layout/spinner';
import { post, get, construirMensaje, parseBackendError } from "../../helpers/apiHttp";

const RegistrarUbicacionPanama = ({ show, handleClose, order, tienda, busqueda }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [provincias, setProvincias] = useState([]);
  const [distritos, setDistritos] = useState([]);
  const [corregimientos, setCorregimientos] = useState([]);
  const [barrios, setBarrios] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formulario, setFormulario] = useState({
    provincia: "",
    distrito: "",
    corregimiento: "",
    barrio: "",
    tienda: "",
    idorden: ""
  });

  const resetFormulario = () => {
    setFormulario({
      provincia: "",
      distrito: "",
      corregimiento: "",
      barrio: "",
      tienda: tienda,
      idorden: order?.data.order_id || "",
    });

    setDistritos([]);
    setCorregimientos([]);
    setBarrios([]);
  };

  useEffect(() => {
    if (show) {
      resetFormulario();
      fetchProvincias(tienda);
    }
  }, [show]);

  const fetchProvincias = async (tienda_id) => {
    const formData = new FormData();

    try {
      let $url = `backend/zones/provinces?tienda=${tienda_id}&idorden=${order?.data.order_id}`;
      //console.log($url);
      setIsLoading(true);
      const data = await get($url);
      setIsLoading(false);

      if (data.statusCode === 200) {
        setProvincias(data.result || []);
      } else {
        Swal.fire('Error', parseBackendError(data.errorMessage), 'error');
        //Swal.fire('Error', 'No se pudieron cargar las provincias', 'error');
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      Swal.fire('Error', 'Error al cargar las provincias', 'error');
    }
  };

  const fetchDistritos = async (tienda_id, provincia) => {
    const formData = new FormData();
    formData.append('tienda', tienda_id);
    formData.append('idorden', formulario.idorden);
    formData.append('id_provincia', provincia);

    try {
      let $url = 'backend/panama/zones/districts';
      setIsLoading(true);
      const data = await post($url, formData);
      setIsLoading(false);

      if (data.statusCode === 200) {
        setDistritos(data.result || []);
      } else {
        Swal.fire('Error', parseBackendError(data.errorMessage), 'error');
        //Swal.fire('Error', 'No se pudieron cargar los distritos', 'error');
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      Swal.fire('Error', 'Error al cargar los distritos', 'error');
    }
  };

  const fetchCorregimientos = async (tienda_id, distrito) => {
    const formData = new FormData();
    formData.append('tienda', tienda_id);
    formData.append('idorden', formulario.idorden);
    formData.append('id_distrito', distrito);

    try {
      let $url = 'backend/panama/zones/subdistricts';
      setIsLoading(true);
      const data = await post($url, formData);
      setIsLoading(false);

      if (data.statusCode === 200) {
        setCorregimientos(data.result || []);
      } else {
        Swal.fire('Error', parseBackendError(data.errorMessage), 'error');
        //Swal.fire('Error', 'No se pudieron cargar los corregimientos', 'error');
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      Swal.fire('Error', 'Error al cargar los corregimientos', 'error');
    }
  };

  const fetchBarrios = async (tienda_id,  corregimiento) => {
    const formData = new FormData();
    formData.append('tienda', tienda_id);
    formData.append('idorden', formulario.idorden);
    formData.append('id_subdistrito', corregimiento);

    try {
      let $url = 'backend/panama/zones/neighborhoods';
      setIsLoading(true);
      const data = await post($url, formData);
      setIsLoading(false);

      if (data.statusCode === 200) {
        setBarrios(data.result || []);
      } else {
        Swal.fire('Error', parseBackendError(data.errorMessage), 'error');
        //Swal.fire('Error', 'No se pudieron cargar los barrios', 'error');
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      Swal.fire('Error', 'Error al cargar los barrios', 'error');
    }
  };

  const handleProvinciaChange = async (event) => {
    const value = event.target.value;

    setFormulario((prevFormulario) => ({
      ...prevFormulario,
      provincia: value,
      distrito: "",
      corregimiento: "",
      barrio: "",
    }));

    setDistritos([]);
    setCorregimientos([]);
    setBarrios([]);

    if (value) {
      await fetchDistritos(tienda, value);
    }
  };

  const handleDistritoChange = async (event) => {
    const value = event.target.value;

    setFormulario((prevFormulario) => ({
      ...prevFormulario,
      distrito: value,
      corregimiento: "",
      barrio: "",
    }));

    setCorregimientos([]);
    setBarrios([]);

    if (value) {
      await fetchCorregimientos(tienda, value);
    }
  };

  const handleCorregimientoChange = async (event) => {
    const value = event.target.value;

    setFormulario((prevFormulario) => ({
      ...prevFormulario,
      corregimiento: value,
      barrio: "",
    }));

    setBarrios([]);

    if (value) {
      await fetchBarrios(tienda, value);
    }
  };

  const handleBarrioChange = (event) => {
    const value = event.target.value;

    setFormulario((prevFormulario) => ({
      ...prevFormulario,
      barrio: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) return;

    if (!formulario.provincia) {
      construirMensaje('', 'Debe seleccionar una provincia', 'warning');
      return;
    }
    if (!formulario.distrito) {
      construirMensaje('', 'Debe seleccionar un distrito', 'warning');
      return;
    }
    if (!formulario.corregimiento) {
      construirMensaje('', 'Debe seleccionar un corregimiento', 'warning');
      return;
    }
    if (!formulario.barrio) {
      construirMensaje('', 'Debe seleccionar un barrio', 'warning');
      return;
    }
    const formData = new FormData();
    formData.append('id_provincia', formulario.corregimiento);
    formData.append('id_city', formulario.barrio);
    formData.append('tienda', formulario.tienda);
    formData.append('idorden', formulario.idorden);

    try {
      setIsSubmitting(true);
      let $url = 'backend/order/zone';
      setIsLoading(true);
      const data = await post($url, formData);
      setIsLoading(false);

      if (data.isSuccessful === true && data.statusCode === 200) {
        construirMensaje(data.errorMessage, 'La ubicación fue actualizada con éxito', 'success');
        busqueda();
        handleClose();
      } else {
        construirMensaje(data.errorMessage, parseBackendError(data.errorMessage), 'error');
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error de formulario',
        text: 'Error al enviar el formulario',
        footer: ''
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <SpinnerComponent />
      ) : (
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Actualizar ciudad destino - Panamá</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form onSubmit={handleSubmit} encType="multipart/form-data">
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Provincia</Form.Label>
                    <Form.Select
                      aria-label="Seleccione una provincia"
                      name="provincia"
                      value={formulario.provincia}
                      onChange={handleProvinciaChange}
                    >
                      <option value="">Seleccione una opción</option>
                      {provincias.map((opcion) => (
                        <option key={opcion.id} value={opcion.id}>
                          {opcion.nombre}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Distrito</Form.Label>
                    <Form.Select
                      aria-label="Seleccione un distrito"
                      name="distrito"
                      value={formulario.distrito}
                      onChange={handleDistritoChange}
                      disabled={!formulario.provincia}
                    >
                      <option value="">Seleccione una opción</option>
                      {distritos.map((opcion) => (
                        <option key={opcion.id} value={opcion.id}>
                          {opcion.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Corregimiento</Form.Label>
                    <Form.Select
                      aria-label="Seleccione un corregimiento"
                      name="corregimiento"
                      value={formulario.corregimiento}
                      onChange={handleCorregimientoChange}
                      disabled={!formulario.distrito}
                    >
                      <option value="">Seleccione una opción</option>
                      {corregimientos.map((opcion) => (
                        <option key={opcion.id} value={opcion.id}>
                          {opcion.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Barrio</Form.Label>
                    <Form.Select
                      aria-label="Seleccione un barrio"
                      name="barrio"
                      value={formulario.barrio}
                      onChange={handleBarrioChange}
                      disabled={!formulario.corregimiento}
                    >
                      <option value="">Seleccione una opción</option>
                      {barrios.map((opcion) => (
                        <option key={opcion.id} value={opcion.id}>
                          {opcion.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cerrar
            </Button>
            <Button variant="primary" type="submit" disabled={isSubmitting} onClick={handleSubmit}>
              Actualizar ciudad destino
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default RegistrarUbicacionPanama;